export default "__VITE_ASSET__BN8Z8PYl__"